// extracted by mini-css-extract-plugin
export default {"root":"styles-scoped__root--ssaLY","error":"styles-scoped__error--odc9E"};